<template>
	<div class="wrap">
		<div class="ycontainer">
			<img
				src="../images/denglu.png"
				mode="heightFix"
				class="ydenglu"
			/>
			<div class="ylogs">
				<div class="ylogsitem">
					<input class="ylogsiteminot" placeholder="请输入手机号" type="number" v-model="email">
				</div>
				<div class="ylogsitem">
					<input class="ylogsiteminot" placeholder="请输入验证码" type="num" v-model="password">
					<van-button class="yangzm" :disabled="yzmshow" @click="getdjs1" size="large">{{!yzmshow? '验证码' : yzm}}</van-button>
				</div>
				<div class="ytip">
					<div class="ytip1">
						<img
						@click="ysshow=!ysshow"
						v-if="!ysshow"
							src="../images/wxuanz.png"
							mode="heightFix"
							class="ytip1img"
						/>
						<img
						@click="ysshow=!ysshow"
						v-if="ysshow"
							src="../images/yxuanz.png"
							mode="heightFix"
							class="ytip1img"
						/>
						<div class="tipte" @click="toxyi">我已阅读用户协议和隐私协议</div>
					</div>
					<div class="tipte1">收不到验证码？</div>
				</div>
				<div class="ydengan1" @click="dologin">
					<span>登录</span>
				</div>
			</div>
			<!-- <div class="login"> -->
				<!-- <van-tabs v-model="activeName" type="card">
					<van-tab title="登录" name="a">
						<div class="adddz login_input">
							<form>
								<div class="address_require">
									<label>邮箱<span>*</span></label>
									<input type="email" v-model="email">
								</div>
								<div class="address_require">
									<label>密码<span>*</span></label>
									<input type="password" v-model="password">
								</div>
								<router-link class="wjmb" :to="{path:'/password'}">忘记密码?</router-link>
								<van-button type="primary"  block v-on:click="dologin()">登录</van-button>
							</form>
						</div>
					</van-tab>
					<van-tab title="注册" name="b">
						<div class="adddz login_input">
							<form @submit="doreg()">
								<div class="address_require">
									<label>邮箱<span>*</span></label>
									<input type="email" v-model="email">
								</div>
								<div class="address_require">
									<label>密码<span>*</span></label>
									<input type="password" v-model="password">
								</div>
								<div class="address_require">
									<label>确认密码<span>*</span></label>
									<input type="password" v-model="password2">
								</div>
								<div class="gw_accept_message">
									<van-checkbox v-model="checkedTP" shape="square" icon-size="18px" checked-color="#000000">
										我已阅读并同意<router-link class="" :to="{path:'/agreement', query:{document: 'termsofusage'}}">《用户协议》</router-link>和
											<router-link class="" :to="{path:'/agreement', query:{document: 'securityandprivacy'}}">《隐私协议》</router-link></van-checkbox>
								</div>
								<van-button type="primary"  block native-type="submit" >创建帐户</van-button>
							</form>
						</div>
					</van-tab>
				</van-tabs> -->
				<!-- <van-divider :style="{ borderColor: '#ddd',margin: '2px 0'}"> OR SIGN IN WITH</van-divider>
				<p class="third_party_discount">
					Sign in with <span>Facebook</span> &amp; <span>Google</span> get <span>$10 off </span>on your first
					order!
				</p>
				<div class="login_kj f-clearfix">
					<div class="google_dl fl"><van-button color="#434343"  icon="https://www.jqxtech.com/images/google-register.png" block type="primary" v-on:click="go_login('google')">Google</van-button></div>
					<div class="facebook_dl fr"><van-button color="#506bae"  icon="https://www.jqxtech.com/images/facebooklogins.png" block type="primary" v-on:click="go_login('facebook')">Facebook</van-button></div>
				</div> -->
			<!-- </div> -->
		</div>
        <coupons-box v-if="user_coupons.length > 0" :user_coupons="user_coupons" :source="source"></coupons-box>
		<!-- <v-foot></v-foot> -->
	</div>
</template>
<style scoped>
.ylogs{
	width: 80%;
	height: 100px;
	/* background: red; */
}
input::placeholder {
  color: #8391A1; /* 设置颜色 */
  font-size: 18px; /* 设置字体大小 */
  
}
.yangzm{
	width: 25%;
	height: 40px;

	background-color: #000000;
	color: #FFFFFF;
	font-size: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
}
.ydengan1{
	width: 100%;
	height: 60px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	/* text-align: center; */
	color: #FFFFFF;
	font-size: 15px;
	background-color: #000000;
	border-radius: 8px;
	margin-top: 30px;
}
.ytip1img{
	height: 16px
}
.tipte{
	font-size: 12px;
	color: #6A707C;
	margin-left: 5px;
}
.tipte1{
	font-size: 14px;
	color: #6A707C;
}
.ytip{
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-top: 10px;
}
.ytip1{
	display: flex;
	flex-direction: row;
}
.ylogsitem{
	width: 100%;
	height: 50px;
	border: 1px solid #E8ECF4;
	border-radius: 8px;
	background: #F7F8F9;
	margin-top: 18px;
	display: flex;
	align-items: center;
	/* justify-content: flex-end; */
	padding: 0 5%;
}
.ylogsiteminot{
	/* width: 50%; */
	flex: 1;
	height: 100%;
	background: #F7F8F9;
	border: none;
	margin: 0 auto;
	color: #8391A1;
	font-size: 18px;
}
.ydenglu{
	height: 85px;
	margin: 40% auto 0 auto;
}
body{
	overflow-x: hidden;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}
*{
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

.ycontainer{
	display: flex;
	flex-direction: column;
	align-items: center;
}
</style>
<script>
    import couponsBox from './coupons_box.vue'
	var _this;
	// @ is an alias to /src
	export default {
		components: {
            couponsBox
        },
        beforeRouteEnter(to,from,next){
			var tmp_reg_from = localStorage.getItem('reg_from');
			if(tmp_reg_from == "" || tmp_reg_from == undefined || from.fullPath !== '/Personal'){
				localStorage.setItem('reg_from',from.fullPath);
			}
            next()
        },
        created(){
			this.token_auto = this.$route.query.token;
			_this = this;
            var reg = this.$route.query.isreg;
            window.console.log(reg)
            if(reg !== undefined && reg === 'other'){
                this.reg = reg;
            }
			if(this.reg == ''){
                if(this.getUserInfo()){
					this.gourl_by_login();
					return;
                }
                this.refreshuinfo(false);
                this.show = true;
            }else {
                this.refreshuinfo(true);
                this.getUserCoupons()
            }

        },
		data() {
			return {
				activeName: 'a',
				checked:'',
				email:'',
				password:'',
				password2:'',
				checkedTP:false,
				token_auto:'',
                user_coupons: [],
                reg: '',
                source:'reg',
				yzm:60,
				yzmshow:false,
				yathimer:null,
				ysshow:false
			}
		},
		methods: {
			toxyi(){
				this.$router.push({
					path:'/agreement',
					query:{document: 'securityandprivacy'}
				})
			},
			getdjs1(){
				let that=this
				if(this.email=='')return this.$toast("请输入手机号");
				this.POST("api/user/RegVerifySend",{"mobile":this.email},function(res){
					console.log('chengg',res.code==0);
					if(res.code==0){
						that.$toast(res.msg)
						that.yzm=60
						that.yathimer = setInterval(() => {
							console.log(121);
						if (that.yzm > 0 ) {
							that.yzmshow = true;
							that.yzm--;
							} else {
							clearInterval(that.yathimer);
							that.yathimer = null;
							that.yzmshow = false;
							}
					}, 1000)
					}else{
						that.$toast(res.msg)
					}
					
				});
			},
			getdjs(){
				// this.$router.push('/carts');
				// this.$toast("发送成功");
				this.yzm=5
				this.yathimer = setInterval(() => {
					console.log(121);
				if (this.yzm > 0 ) {
					this.yzmshow = true;
					this.yzm--;
					} else {
					clearInterval(this.yathimer);
					this.yathimer = null;
					this.yzmshow = false;
					}
			}, 1000)

			},
			dologin(){
				if(this.email=='')return this.$toast("请输入手机号");
				if(this.password=='')return this.$toast("请输入验证码");
				if(!this.ysshow) return _this.$toast("请同意隐私协议");
				this.POST("api/user/Reg",{"mobile":this.email,"verify":this.password},function(d){
						window.console.log(d);
					if(d.code != 0){
						_this.$toast(d.msg);
					}else{
						var result = _this.setUserInfo(d.data);
						if(result){
                            window.console.log(localStorage.getItem('reg_from'));
							_this.gourl_by_login();
						}else{
							_this.$toast("Error");
						}
					}
				});
			},
			doreg(){
				var agreement = this.checkedTP ? "on" : "";
				this.POST("api/user/register",{"accounts":this.email,"pwd":this.password,"pwd2":this.password2,"type":"emailnotauth","agreement":agreement},function(d){
						window.console.log(d);
					if(d.code != 0){
						_this.$toast(d.msg);
					}else{
						var result = _this.setUserInfo(d.data.data.user_info);
						if(result){
                            _this.user_coupons = d.data.data.user_coupon;
							//_this.$router.push('personal');
						}else{
							_this.$toast("Error");
						}
					}
				});
			},
			refreshuinfo(status){
				if(this.token_auto != ""){
					this.POST("api/user/refreshuinfo",{"token":this.token_auto},function(d){
						if(d.code != 0){
							// _this.$toast(d.msg);
						}else{
                            var result = _this.setUserInfo(d.data.data.user_info);
                            if(!status){
                                if(result){
									this.gourl_by_login();
                                }else{
                                    _this.$toast("Error");
                                }
                            }
						}
					});
				}
			},
			go_login(type){
				// var url_back = window.location.origin+"/"+window.location.hash;
				if(type == "google"){
					// window.location.href = "https://www.jqxtech.com/index/user/login_third_h5?type=google&url_back="+encodeURIComponent(url_back);
					window.location.href = "https://accounts.google.com/o/oauth2/auth?response_type=code&redirect_uri=https%3a%2f%2fshopping.alijietu.com%2findex%2fuser%2fcallback%2fname%2fgoogle.html&client_id=963852005643-lo0674p97t8mne8if4tlcegugkssnb80.apps.googleusercontent.com&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&access_type=offline&approval_prompt=auto";
				}else if(type == "facebook"){
					// window.location.href = "https://www.jqxtech.com/index/user/login_third_h5?type=facebook&url_back="+encodeURIComponent(url_back);
					window.location.href = "https://m.facebook.com/dialog/oauth?client_id=959585611138839&redirect_uri=https%3a%2f%2fshopping.alijietu.com%2findex%2fuser%2fcallback%2fname%2ffacebook.html&scope=public_profile,email";
				}
			},
            getUserCoupons(){
                var url = 'api/coupon/couponsList';
                var data = {token:this.token_auto};

                this.POST(url,data,function (ret) {
                    if(ret.code === 0){
                        _this.user_coupons = ret.data.user_coupons;
                        _this.source = 'close'
                    }
                })
            }
			
		},
	}
</script>